import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchLidLabels = createProvider(api.fetchLidLabels)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch lid labels aborted');
    } else {
      console.error('Fetch lid labels was failed:', error);
    }
    throw error;
  });
